import { render } from "./detail.vue?vue&type=template&id=81035444&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=81035444&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81035444"],['__file',"src/views/guide/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81035444"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81035444', __exports__)) {
    console.log('reload')
    api.reload('81035444', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=81035444&scoped=true", () => {
    console.log('re-render')
    api.rerender('81035444', render)
  })

}


export default __exports__